<template>
    <div class="af" >
        <el-form class="table" v-loading="loading" :model="formData" :rules="formRules" ref="formRef"  size="mini">


            <div class="flex borb ma4">
                <el-form-item class="long form-title flex" prop="gsname" :label="$t('saleInvoicing_customer_taxpayer_identification_number')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_creditcode}}</span>
                </el-form-item>
                <el-form-item class="form-title flex alc" prop="gsname" :label="$t('saleInvoicing_raise')" >
                    <el-radio-group class=" flex alc wid100" v-model="formData.i_title_type"  @input="changeTt">
                        <el-radio :label="1">{{$t('saleInvoicing_enterprise')}}</el-radio>
                        <el-radio :label="2">{{$t('saleInvoicing_individual')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="form-title flex alc" prop="gsname" :label="$t('saleInvoicing_kaipiao_type')" >
                    <el-select class="wid100"  @change="changeData($event,'kplx')" @clear="clearsearch('kplx')"  v-model="formData.vc_invoice_type" size="mini" clearable filterable :placeholder="$t('saleInvoicing_please_select_the_invoicing_type')">
                        <el-option
                                v-for="item in kplxData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.i_id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="flex borb ma4">
                <el-form-item class="wid50 flex" prop="gsname" :label="$t('saleInvoicing_bank_of_deposit')" >
                    <el-input class="wid100"  v-model="formData.vc_bank">
                    </el-input>
                </el-form-item>
                <el-form-item class="wid50 flex" prop="gsname" :label="$t('saleInvoicing_branch_of_the_account_opening_bank')" >
                    <el-input class="wid100"  v-model="formData.vc_bank_sub">
                    </el-input>
                </el-form-item>
                <el-form-item class="wid50 flex" prop="gsname" :label="$t('saleInvoicing_account_number_of_the_bank_of_deposit')" >
                    <el-input class="wid100"  v-model="formData.vc_bank_account">
                    </el-input>
                </el-form-item>
            </div>
            <div class="flex borb ma4">
                <el-form-item class="wid50 flex" prop="gsname" :label="$t('saleInvoicing_telephone')" >
                    <el-input class="wid100"  v-model="formData.vc_tel">
                    </el-input>
                </el-form-item>
                <el-form-item class="wid50 flex" prop="gsname" :label="$t('saleInvoicing_email')" >
                    <el-input class="wid100" @change="checkemail"  v-model="formData.vc_email">
                    </el-input>
                </el-form-item>
            </div>
            <div class="flex borb ma4">
                <el-form-item class="width100_f flex" prop="gsname" :label="$t('saleInvoicing_address')" >
                    <el-input class="wid100"  v-model="formData.vc_address">
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveClick"  :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {
        },
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data(){
            return{
                i_isspec:0,
                kpData:[],
                kplxData:[],
                loading:false,
                formData:{

                },
                formRules:{
                    //f_num:[{required:true,message:"请填写出库量",trigger:"blur"},],
                },
                baseerp:"",
                mid:0,
            }
        },
        mounted() {
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            this.invoicetype();
            //console.log(this.Data,'Data');
            this.formData=this.Data;
        },
        methods:{

            saveClick(){
                if(this.formData.i_invoice_type==null){
                    this.$message.error(this.$t('saleInvoicing_please_select_the_invoicing_type'));
                    return
                }
                /*if(this.i_isspec==1&&this.formData.i_title_type==1){
                    if(this.formData.vc_bank==''){
                        this.$message.error('请填写开户行');
                        return
                    }
                    if(this.formData.vc_bank_sub==''){
                        this.$message.error('请填写开户支行');
                        return
                    }
                    if(this.formData.vc_bank_account==''){
                        this.$message.error('请填写开户行帐号');
                        return
                    }
                    if(this.formData.vc_address==''){
                        this.$message.error('请填写地址');
                        return
                    }
                    if(this.formData.vc_tel==''){
                        this.$message.error('请填写电话');
                        return
                    }
                }*/
                /*if(this.formData.vc_email==''){
                    this.$message.error('请填写正确邮箱');
                    return
                }*/
                let emailArr = [];
                if(this.formData.vc_email!=''){
                    emailArr.push(this.formData.vc_email)
                }else{
                    emailArr = [];
                }

                /*this.emailList=this.emailList.filter(e=>e!=='')
                if(this.emailList.length==0){
                    this.$error('请填写邮箱')
                    this.emailList=[
                        "",
                    ];
                    return
                }*/
                this.addKhBankAndZh(emailArr);
            },
            async addKhBankAndZh(emailArr){
                let param={
                    i_id:this.formData.i_kpzlid,
                    i_khid:this.formData.i_khid,
                    i_khtype:1,
                    i_type:2,
                    vc_bank:this.formData.vc_bank,
                    vc_bank_sub:this.formData.vc_bank_sub,
                    vc_account:this.formData.vc_bank_account,
                    //开票类型
                    i_kptype:this.formData.i_invoice_type,
                    vc_address:this.formData.vc_address,
                    vc_tel:this.formData.vc_tel,
                    //抬头类型
                    i_title_type:this.formData.i_title_type,
                    emailArr:emailArr,
                };
                let res=await API.addKhBankAndZh(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.$emit('close',this.formData)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }

            },

            checkemail(){
                if(this.formData.vc_email!=''){
                    let ZQ =  this.emailTest(this.formData.vc_email)
                    if(ZQ==false){
                        this.$message.error(this.$t('saleInvoicing_please_enter_the_correct_email_address'));
                        this.formData.vc_email='';
                    }
                }

            },
            /* 邮箱验证 */
            emailTest(email){
                let emailRegExp=/^[0-9a-zA-Z][a-zA-Z0-9\._-]{1,}@[a-zA-Z0-9\._-]{1,}[a-zA-Z0-9\._-](\.[a-zA-Z]{1,})+$/
                // let emailRegExp=/^[a-zA-z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-z0-9_-]+)+$/;
                if(emailRegExp.test(email)){
                    return true
                }else{
                    return false
                }
            },

            changeTt(e){
                this.i_title_type=e;
                this.kplxData = [];
                this.kplxData = this.i_title_type==2?this.kpData.filter(kp=>kp.i_isspec==0):this.kpData
            },
            changeData(e,type){
                if(type=='kplx'){
                    this.formData.i_invoice_type=e;
                    let choo = this.kplxData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.i_isspec=choo[0].i_isspec;
                        this.formData.vc_invoice_type=choo[0].vc_name;
                    }else{
                        this.i_isspec=null;
                        this.formData.vc_invoice_type='';
                    }
                }
            },
            clearsearch(type){
                if(type=='kplx'){
                    this.i_isspec=null;
                    this.formData.i_invoice_type=null;
                    this.formData.vc_invoice_type='';
                }
            },
            //开票类型
            async invoicetype(){
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.invoicetype(param);
                if (res.code == 1) {
                    this.kpData = res.data.list;
                    this.kplxData = this.kpData;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancel(){
                this.$emit('close')
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
        }
    }
</script>

<style  lang="scss" scoped>
    .marr4{
        margin-right: 4px;
    }
    .alc{
        align-items: center;
    }
    .point{
        font-size: 10px;
        color: #fa5050;
        height: 10px;
        line-height: 10px;
    }
    /deep/.el-input__suffix{
        right: 12px;
    }
    /deep/.nodata .el-input__inner{
        padding: 0 9px;
    }
    .wid100{
        width: 100%;
    }

    .mar3{
        margin:3px 0px;
    }
    .moren .el-form-item__label{
        width:150px !important;
    }
    .inputw{
        //width:calc(100% - 90px);
    }
    .wid50{
        width: calc(50% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .wid100_bz{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }
    .mart20{
        margin-top: 20px;
    }
    .borb{
        //border-bottom: 1px solid #efefef;
        //margin-top: 1px;
    }
    .fr{
        float: right;
    }
    .wid60{
        width: 60%;
    }
    .width100_f{
        width: calc(100% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .wid66{
        width: calc(66% - 30px) !important;
        padding-right: 20px;
        padding-left: 10px;
    }

    .form-title{
        width: calc(33% - 30px) !important;
        padding-right: 20px;
        padding-left: 12px;
        display: flex;
    }
    .flex{
        display: flex;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
    }

    .num .el-form-item__label {
        color: #b3d268;
        font-size: 16px;
        font-style: italic;
    }
    .num .el-form-item__content {
        width: 150px;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .tableForm-item{
        margin: 0;
        width: 100%;
        /deep/{
            .el-form-item__content{
                width: 100%;
                margin-left: 0 !important;
            }
        }
    }
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
    }
    /deep/.guding{
        /*.el-form-item__label{*/
        /*    min-width: 85px !important;*/
        /*    margin-right: 3px !important;*/
        /*}*/
    }

    /deep/.table {
        .el-form-item--mini.el-form-item, .table.el-form-item--small.el-form-item {
            margin-bottom: 0px;
        }
        .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 84px;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }
        .long .el-form-item__label{
            text-align: left;
            color: #808080;
            min-width: 120px !important;
            margin-right: 9px;
            padding: 0px !important;
            font-size: 14px !important;
        }
        .el-input--mini .el-input__inner{
            height: 24px;
            line-height: 24px;
        }
        .el-form-item__content{
            width: 100%;
        }
    }


</style>
